import api from './api';

/**
 * Certificate-request routing for a compliance subject ↔ agency link.
 */
export async function fetchCertificateRoute(subjectId, agentLinkId) {
  const response = await api.get(
    `/compliance-subjects/${subjectId}/agents/${agentLinkId}/certificate-route/`,
  );
  return response.data?.certificate_route || null;
}

export async function confirmCertificateRoute(subjectId, agentLinkId, payload) {
  const response = await api.post(
    `/compliance-subjects/${subjectId}/agents/${agentLinkId}/certificate-route/confirm/`,
    payload,
  );
  return response.data;
}

export async function rejectCertificateRoute(subjectId, agentLinkId, payload) {
  const response = await api.post(
    `/compliance-subjects/${subjectId}/agents/${agentLinkId}/certificate-route/reject/`,
    payload,
  );
  return response.data;
}

export async function clearCertificateRoute(subjectId, agentLinkId) {
  const response = await api.delete(
    `/compliance-subjects/${subjectId}/agents/${agentLinkId}/certificate-route/`,
  );
  return response.data;
}
